<template>
  <div class="tongxin-layout">
    <SelectionStep title="請選擇就診目的" :items="items" v-model="selectedItem" />

    <div class="fixed-footer-navigation">
      <TongxinNavigation
        :canProceed="!isLoading"
        :backButtonIsVisible="true"
        :nextButtonIsVisible="true"
        textForNextStep="下一步"
        @back="goBack"
        @next="handleSubmit"
      />
    </div>

    <div v-if="isLoading" class="loading-overlay">
      <b-spinner style="border-width: 2px" />
    </div>
  </div>
</template>

<script>
import TongxinNavigation from '@/components/web/proj/tongxin/layout/TongxinNavigation.vue'
import SelectionStep from '@/components/web/proj/tongxin/SelectionStep.vue'

export default {
  components: {
    TongxinNavigation,
    SelectionStep
  },
  data() {
    return {
      selectedItem: null,
      isLoading: false,
    }
  },
  computed: {
    items() {
      return [
        {
          label: '一般看診',
          value: 'outpatient',
        },
        {
          label: '體檢/健檢',
          value: 'health',
        },
        {
          label: '注射疫苗',
          value: 'vaccine',
        },
      ]
    },
  },
  methods: {
    handleSubmit(e) {
      if (!this.selectedItem) {
        return
      }

      const query = { sourceType: this.selectedItem }
      if (this.$route.query.from) {
        query.from = this.$route.query.from
      }
      if (this.$route.query.clinicCode) {
        query.clinicCode = this.$route.query.clinicCode
      }

      this.$router.push({ name: 'WebProjTongxin', query })
    },

    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style lang="scss" scoped>
.tongxin-layout {
  padding-bottom: 100px;
}
</style>
